import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ItemType from '../ItemType';
import { requiredItemsLabel, maximumChoicesLabel, isRequirementUnmet, getAllChildItems, menuRequirement, menuRequirementLabel } from '../../services/product';
import PropTypes from 'prop-types';

function ProductGroup({ item, quote }) {
  let items = _.orderBy(
    _.filter(quote.menu, { parent_id: item.id }),
    '_lft',
  );

  const selectedCount = getAllChildItems(item, quote.menu).filter((child) => (
    child.id !== item.id && child.depth === item.depth + 1 && child.selected === true
  )).length;
  const requirement = menuRequirement(item, quote.menu);

  return (
    <div id={'MenuItem' + item.id}>
      <div className="row">
        <div className="col">
          <div className="float-start">
            <h2 className="product-group-title" id={`menu-group-title-${item.id}`} tabIndex={-1}>
              {item.label}
              </h2>
            <div className={'product-group-description'}>
              {item.description}
            </div>
            {requirement && isRequirementUnmet(item, quote.menu) && <p className="required-course-hint">
              Required: {menuRequirementLabel(requirement)}.
            </p>}
          </div>
          <div className="float-end">
            {(!_.isNull(item.minimum_choices) && item.minimum_choices > 0 && isRequirementUnmet(item, quote.menu)) && (
              <span className="badge badge-warning me-1">
                {requiredItemsLabel(item)}
              </span>
            )}
            {item.maximum_choices > 0 && (
              <span className="badge badge-neutral">
                {maximumChoicesLabel(item, quote.menu)} · {selectedCount} selected
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={'product-group'}>
        {items.map((item) => (
          <ItemType key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}
const mapStateToProps = function (state) {
  return {
    quote: state.quote,
  };
};

ProductGroup.propTypes = {
  item: PropTypes.object,
  quote: PropTypes.object
};

export default connect(mapStateToProps)(ProductGroup);
